import {
  type SearchableField,
  SearchableFieldType,
} from './ISearchableField.tsx';

export function isSearchableFieldRowActive(
  query: Record<string, any>,
  field: SearchableField,
) {
  switch (field.type) {
    case SearchableFieldType.DateRange:
    case SearchableFieldType.NumberRange:
      return (
        query[field.from.name] !== undefined ||
        query[field.to.name] !== undefined
      );

    default:
      return query[field.name] !== undefined;
  }
}
